/* ================================================== */
/* CONTACT FORM
/* ================================================== */	    

$(document).ready(function(){

  // --- submit form --- //

	var form = $('.blockForm');
	// var lang = $('html').attr('lang');
	// var baseUrl = $('base').attr('href') + lang;

	function removeErrors(){
    $('.form__notifications .error, .form__notifications .success').fadeOut();
    $('.input .errors').text('');
    $('input,select,button,textarea').css({
    	'outline': 'none'
    });
	}

	form.on('keyup', 'input', function(){
		$(this).css({'outline': 'none'}).parents('.input').find('.errors').text('');
	});

	form.on('submit', function(e) {
    e.preventDefault();
    
    // Remove any existing error messages from previous attempts
    removeErrors();
    
    // Get the post data
    var data = $(this).serialize();
    data[window.csrfTokenName] = window.csrfTokenValue;

    // Send it to the server
    $.ajax({
      type: 'POST',
      url: '/',
      dataType: 'json',
      data: data,
      beforeSend: function(response, statut){
      	$('input[type="submit"]').attr('disabled', true);
      },
      success: function(response, statut){

        if (response.success == true) {
        	console.log('response success');
        	
        	$('.form-group, .form-submit').fadeOut();
        	$('.form__notifications .success').fadeIn();

        } else {
        	console.log('response error');
        
        	// Display Error(s) Message
        	$('.form__notifications .error').fadeIn();
					$.each(response.validationErrors, function(key, value) {
					  $('input#'+key).css({
        			'outline': '#f44336 auto 5px'
					  }).parents('.input').find('.errors').text(value);
					});

	        // -- Enable submit btn --
	        $('input[type="submit"]').attr('disabled', false);

        }     
      },
      error: function(response, statut, error){
        console.log('Ajax error');
        console.log(response);
        
        // -- Enable submit btn --
        $('input[type="submit"]').attr('disabled', false);


      }
    });

	});
});